<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import DocumentList from '../../Document/DocumentList.vue'
import DocumentSignBlock from '../../Document/DocumentSignBlock.vue'
import MissingDeliveryDateAlert from './MissingDeliveryDateAlert.vue'

export default {
  components: { MissingDeliveryDateAlert, DocumentSignBlock, DocumentList, ButtonAll },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    delivery: { type: Object, required: true },
    contractNumber: { type: String, default: '' },
    uuid: { type: [String, null, undefined], default: null, required: false },
  },

  data: () => ({
    visualizePV: true,
    downloading: false,
  }),

  computed: {
    verifyDocuments() {
      return this.delivery.documentAssoc !== null
    },
    verifyFullSign() {
      if (this.delivery.leaseback) {
        return !!this.delivery.deliveredAt
      } else if (this.delivery.esign && this.verifyDocuments) {
        let document = this.delivery.documentAssoc.document
        if (document.documentSignFiles.length > 0) {
          for (const [index, documentSignFileStatuses] of Object.entries(
            document.documentSignFiles[0].documentSignFileStatuses,
          )) {
            if (documentSignFileStatuses.status !== 'SIGNED' && documentSignFileStatuses.status !== 'SIGNED_FULL') {
              return false
            }
          }
          return true
        }
      } else {
        return !!this.delivery.id && null !== this.delivery.deliveredAt
      }

      return false
    },
    verifyVisualizePV() {
      if (this.delivery.id) {
        if (this.delivery.esign) {
          return this.delivery.documentAssoc !== null && this.visualizePV
        } else {
          return this.visualizePV
        }
      }

      return false
    },
    deliveryNumber() {
      return this.contractNumber + '-' + this.delivery.id
    },
    missingDeliveryDate() {
      return null !== this.delivery.id && null === this.delivery.deliveredAt
    },
    inSignature() {
      return this.delivery.documentAssoc?.document.documentSignFiles.length > 0
    },
  },

  methods: {
    documentLoaded(json) {
      this.visualizePV = json.missings.length !== 0 && !this.delivery.esign
    },
    async download() {
      let url = `deliveryorder/${this.delivery.id}/download`
      if (this.uuid) {
        url = 'free/' + url
      }

      this.downloading = true
      await this.downloadFile(url, this.$t('delivery.document.fileName', { deliveryNumber: this.deliveryNumber }))
      this.downloading = false
    },
    documentUploaded(document) {
      if (document.documentType.internalName === 'delivery_order') {
        location.reload()
      }
    },
  },
}
</script>
<template>
  <div id="delivery-sign">
    <div v-if="verifyDocuments">
      <div id="sign" class="col-12 text-center">
        <DocumentSignBlock
          v-if="inSignature"
          :document-assoc-id="delivery.documentAssoc.id"
          :document="delivery.documentAssoc.document"
          :uuid="uuid"
        />

        <template v-else-if="delivery.esign">
          <p>
            <b>{{ $t('delivery.esign') }}</b>
          </p>
          <br />
        </template>
        <p v-if="inSignature && !verifyFullSign">
          <b>{{ $t('delivery.download') }}</b>
        </p>
        <p v-else-if="!verifyFullSign">
          <b>{{ $t('delivery.manualSign') }}</b>
        </p>
      </div>
    </div>

    <div v-if="verifyVisualizePV" id="sign" class="text-center">
      <ButtonAll
        type="info"
        label="delivery.visualizePV"
        large
        :loading="downloading"
        @click="download"
        e2e-button="deliveryOrderDownload"
      />
    </div>

    <div v-if="verifyFullSign && delivery.id !== null" class="mt-4">
      <h4 v-html="$t('contract.document.title')"></h4>
      <DocumentList
        id="delivery-sign"
        restrict="supplier"
        context="DeliveryOrder"
        :context-id="delivery.id"
        :uuid="uuid"
        @document-loaded="documentLoaded"
        @document-uploaded="documentUploaded"
      ></DocumentList>
    </div>
    <MissingDeliveryDateAlert v-else-if="missingDeliveryDate" class="mt-4" />
  </div>
</template>
